"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MERKLE_HASH_VERSIONS = void 0;
exports.MERKLE_HASH_VERSIONS = {
    ONE: 1,
    TWO: 2,
    UNSET: NaN,
};
//# sourceMappingURL=constants.js.map